import { getEnumValues } from './get-enum-values';
export enum DepthChartType{
	Standard ='standard',
	Formation ='formation',
	Template='template',
	GlobalTemplate='global-template',
}
export const DepthChartTypeValues = getEnumValues <DepthChartType>(DepthChartType)